// extracted by mini-css-extract-plugin
export default {"tag":"SearchTags_tag__K+QAi","bar":"SearchTags_bar__Hqi2q","closeButton":"SearchTags_closeButton__lJAkh","showAll":"SearchTags_showAll__TPtxA"};